import React from 'react';

export default function TestStudentField({ checked, onChange, disabled = false }) {
  return <div className="space-y-1">
    <label className="flex items-center gap-2 text-sm text-gray-700">
      <input type="checkbox" checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} className="size-4 rounded border-gray-300 accent-primary focus-visible:ring-2 focus-visible:ring-primary" />
      테스트 학생
    </label>
    <p className="text-xs text-gray-500">통계와 입학률에서 제외합니다. 학생 명부와 캘린더에는 표시됩니다.</p>
  </div>;
}
